import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";

export function getPasswordStrength(password) {
  const pw = password || "";
  const criteria = {
    length8: pw.length >= 8,
    length12: pw.length >= 12,
    lowercase: /[a-z]/.test(pw),
    uppercase: /[A-Z]/.test(pw),
    digit: /\d/.test(pw),
    symbol: /[^A-Za-z0-9]/.test(pw),
  };
  const score = Object.values(criteria).filter(Boolean).length;
  let level = "weak";
  if (score >= 5) level = "strong";
  else if (score >= 3) level = "medium";
  return { score, level, criteria };
}

const LEVEL_STYLES = {
  weak: { bar: "bg-rose-600", text: "text-rose-700", segments: 1 },
  medium: { bar: "bg-amber-600", text: "text-amber-700", segments: 2 },
  strong: { bar: "bg-emerald-600", text: "text-emerald-700", segments: 3 },
};

export default function PasswordStrengthMeter({ password }) {
  const { t } = useTranslation("auth");
  if (!password) return null;

  const { level } = getPasswordStrength(password);
  const styles = LEVEL_STYLES[level];

  return (
    <div className="mt-1.5" data-testid="password-strength-meter">
      <div className="flex gap-1" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={cn(
              "h-1 flex-1 rounded-full transition-colors",
              i < styles.segments ? styles.bar : "bg-zinc-200"
            )}
          />
        ))}
      </div>
      <p className={cn("text-[11px] mt-1", styles.text)} data-testid="password-strength-label">
        {t(`password_strength.${level}`)}
      </p>
    </div>
  );
}
